var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 22",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 10H10.86a4 4 0 0 0-7.72 0H0v2h3.14a4 4 0 0 0 7.72 0H22ZM7 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 3h-1.14a4 4 0 0 0-7.72 0H0v2h13.14a4 4 0 0 0 7.72 0H22Zm-5 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2M17 14a4 4 0 0 0-3.86 3H0v2h13.14a4 4 0 0 0 7.72 0H22v-2h-1.14A4 4 0 0 0 17 14m0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.de49889a288c3249b83a056d8db2b806.svg";